export default 'icon--search';